// @flow
import React, { type Node } from 'react';
import { useEventBusListener } from '@tectonics/public-event-bus';
import { useUserInputValue } from '@tectonics/prs/user-input-values';
import { Empty } from '../../../atoms';

export function SelectedPaymentMethod(): Node {
  const [, handleSelectedPaymentMethodChange] = useUserInputValue('selectedPaymentMethod');

  useEventBusListener('userInputValues:change', ({ selectedPaymentMethod }) => {
    handleSelectedPaymentMethodChange(selectedPaymentMethod);
  });

  return <Empty />;
}
